<div class="mb-6">
  <!-- Breadcrumb -->
  <nav
    class="flex items-center gap-1 py-4 hover:text-primary-500"
    aria-label="Breadcrumb"
  >
    @for (item of displayBreadcrumbs; track item.route; let last = $last) {
      <div class="flex items-center gap-1">
        @if (item.route && !last) {
          <a
            [routerLink]="item.route"
            class="text-sm text-greyscale-400 transition-colors hover:text-primary-500"
          >
            {{
              item.translationKey
                ? (item.translationKey | transloco)
                : item.label
            }}
          </a>
        } @else {
          <span class="text-sm text-greyscale-400">
            {{
              item.translationKey
                ? (item.translationKey | transloco)
                : item.label
            }}
          </span>
        }

        @if (!last) {
          <lucide-icon
            name="chevron-right"
            [size]="16"
            class="text-greyscale-400"
          />
        }
      </div>
    }
  </nav>

  <!-- Title + Actions -->
  @if (title || (actions && actions.length > 0)) {
    <div class="flex min-h-[48px] items-center justify-between">
      <h1 class="font-cabin text-4xl font-medium text-primary-900">
        {{ title }}
      </h1>

      <div class="flex gap-3">
        <!-- Je casse un peu l'idée initial du truc, mais je trouve que ça manque un peu de flexibilité -->
        <ng-content />
        @if (actions && actions.length > 0) {
          @for (action of actions; track action.label) {
            @if (!action.hide) {
              @if (action.variant === "outlined") {
                <p-button
                  [label]="action.label | transloco"
                  [icon]="action.icon ? 'pi pi-' + action.icon : ''"
                  severity="secondary"
                  [outlined]="true"
                  (onClick)="action.onClick ? action.onClick() : null"
                  [routerLink]="action.routerLink"
                  class="outlined-button"
                  [attr.data-testid]="action.testId"
                  [loading]="action.loading"
                >
                  @if (action.badge) {
                    <span [class]="getBadgeClass(action.badge.variant)">
                      {{ action.badge.text }}
                    </span>
                  }
                </p-button>
              } @else {
                <p-button
                  [label]="action.label | transloco"
                  [icon]="action.icon ? 'pi pi-' + action.icon : ''"
                  (onClick)="action.onClick ? action.onClick() : null"
                  [routerLink]="action.routerLink"
                  [attr.data-testid]="action.testId"
                  [loading]="action.loading"
                >
                  @if (action.badge) {
                    <span [class]="getBadgeClass(action.badge.variant)">
                      {{ action.badge.text }}
                    </span>
                  }
                </p-button>
              }
            }
          }
        }
      </div>
    </div>
  }
</div>
